// extracted by mini-css-extract-plugin
module.exports = {"link":"DonationRecord_link_2p1C7"};
    if(module.hot) {
      // 1789136764310
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  